import { Injectable } from '@angular/core';
import { Filter, FilterGroup, FilterGroupType, RuleOperator } from '../../core/store/models';
import { cloneDeep } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class FieldFilterService {
  constructor() {}

  public combineFilterGroup(filterGroup: FilterGroup, anotherFilterGroup: FilterGroup): FilterGroup {
    let result = filterGroup;
    let expandedGroup = {
      groupType: FilterGroupType.And,
      filters: [],
      filterGroups: []
    } as FilterGroup;
    if (!!result) {
      expandedGroup.filterGroups.push(cloneDeep(result));
      if (!!anotherFilterGroup) {
        expandedGroup.filterGroups.push(anotherFilterGroup);
      }
      result = expandedGroup;
    } else if (!!anotherFilterGroup) {
      expandedGroup.filterGroups.push(anotherFilterGroup);
      result = expandedGroup;
    }

    return result;
  }

  public findFilterByField(filterGroup: FilterGroup, field: string): Filter {
    let filter = filterGroup.filters?.find(f => f.field === field);
    if (!!filter) {
      return filter;
    }
    filterGroup.filterGroups?.forEach(g => {
      filter = this.findFilterByField(g, field);
      if (!!field) {
        return filter;
      }
    })
    return null;
  }
}
